import React from "react";
import HeadingBox from "./homecomponent/headingBox";
import TeamOwnerBox from "./homecomponent/teamOwnerBox";

const Team = () => {
  const topHead = "TEAM";
  const subHead = "Meet Our Team";

  const teamimgs1 = "/images/home/newGirl.png";
  const teamimgs2 = "/images/home/team2.png";
  const teamimgs3 = "/images/home/team3.png";

  const teamName1 = "Sarah Aileah";
  const teamName2 = "Jonathan Leon";
  const teamName3 = "Dean Johaness";

  const teamjob1 = "Manager";
  const teamjob2 = "CEO";
  const teamjob3 = "Chief Marketing";

  return (
    <>
      <div className="teamWrapper" id="team">
        <HeadingBox topheading={topHead} subheading={subHead} />
        <img
          className="clockblueprintLeft"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />

        <img
          className="clockblueprintRight"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />
        <div className="teamOwnerBoxContainer">
          <TeamOwnerBox
            teamImage={teamimgs1}
            teamname={teamName1}
            teamjob={teamjob1}
          />
          <TeamOwnerBox
            teamImage={teamimgs2}
            teamname={teamName2}
            teamjob={teamjob2}
          />
          <TeamOwnerBox
            teamImage={teamimgs3}
            teamname={teamName3}
            teamjob={teamjob3}
          />
        </div>
      </div>
    </>
  );
};

export default Team;
